import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { ReachComponent } from './reach.component';

export default angular
    .module('control-room.experience-promoter.components.experience-manage.components.reach', [])
    .directive('crReach', downgradeComponent({ component: ReachComponent }));
